import axios from '@axios'

/** 
* Índice
* {@link getEconomicActivities} - Obtener actividades económicas
* {@link getEconomicActivity} - Obtener actividad económica
* {@link addEconomicActivity} - Crear actividad económica
* {@link deleteEconomicActivity} - Eliminar actividad económica
* {@link updateEconomicActivity} - Actualizar actividad económica
*/

    /**
     * Obtener todads las actividades económicas
     * @param {*} queryParams 
     * @returns evaluations 
     */
    export const getEconomicActivities = function (queryParams) {
        try {
            return new Promise((resolve, reject) => {
                axios
                    .get('/economic-activities', { params: queryParams })
                    .then(response => resolve(response))
                    .catch(error => reject(error))
            })

        } catch (error) {
            return error
        }
    }

    /**
     * Obtener actividad económica
     * @param {integer} id ID de la actividad económica 
     * @returns serie
     */

    export const getEconomicActivity = function ( id ) {
        try {
            return new Promise((resolve, reject) => {
                axios
                    .get(`/economic-activities/${id}`)
                    .then(response => resolve(response))
                    .catch(error => reject(error))
            })

        } catch (error) {
            return error
        }
    }

    /**
     * Añadir actividad económica
     * @param {*} data Datos del cliente 
     * @returns 
     */

    export const addEconomicActivity = function (data) {
        try {
            return new Promise((resolve, reject) => {
                axios
                    .post(`/economic-activities`, data)
                    .then(response => resolve(response))
                    .catch(error => reject(error))
            })

        } catch (error) {
            return error
        }
    }

    /**
     * Borrar actividad económica
     * @param {integer} id ID de la actividad económica a borrar
     * @returns 
     */

    export const deleteEconomicActivity = function ({ id }) {
        try {
            return new Promise((resolve, reject) => {
                axios
                    .delete(`/economic-activities/${id}`)
                    .then(response => resolve(response))
                    .catch(error => reject(error))
            })

        } catch (error) {
            return error
        }
    }

    /**
     * Actualizar actividad económica
     * @param {integer} id ID de la actividad económica a actualizar 
     * @returns 
     */

    export const updateEconomicActivity = function (data) {
        try {
            return new Promise((resolve, reject) => {
                axios
                    .put(`/economic-activities/${data.id}`, data)
                    .then(response => resolve(response))
                    .catch(error => reject(error))
            })

        } catch (error) {
            return error
        }
    }










